<template>
  <!-- 房东 -->
  <div class="landlord">
    <!-- 收益 -->
    <div class="earnings">
      <!-- 账单明细 -->
      <div class="bill">
        <p @click="$router.push('/withdraw-deposit')">
          提现
        </p>
        <p @click="emitToparent">
          账单明细
        </p>
      </div>
      <p class="one-title" @click="$router.push('/withdrawal-record')">
        收益（元）（提现记录）
      </p>
      <!-- 总收益 -->
      <p class="earnings-money">
        {{list.count_earnings}}
      </p>
      <!-- 具体收益 -->
      <div class="three-kinds-of">
        <div class="sy">
          <p>
            收益
          </p>
          <p>
            {{list.count_earnings | addPriceIcon}}
          </p>
        </div>
        <span></span>
        <div class="fc">
          <p>
            分成
          </p>
          <p>
            {{list.count_deduction | addPriceIcon}}
          </p>
        </div>
        <span></span>
        <div class="zc">
          <p>
            支出
          </p>
          <p>
            {{list.count_expenditure | addPriceIcon}}
          </p>
        </div>
      </div>
    </div>
    <!-- 具体信息 -->
    <div class="landlord-content" v-for="(item,index) in list.data" :key="index"> 
      <!-- 位置 时间 -->
      <div class="location-time">
        <span></span>
        <p class="address">{{item.housing_name}}</p>
        <p class="date">{{item.checketime}}</p>
      </div>
      <!-- 人员信息 -->
      <div class="personal-information">
        <p>
          入住人
        </p>
        <p>
          {{item.checkinperson}}
        </p>
        <p>
          {{item.sex === 1 ? '男' : '女' }}
        </p>
      </div>
      <!-- 入住时间 -->
      <!-- <div class="personal-information">
        <p>
          入住时间
        </p>
        <p>
          {{item.checkstime}}
        </p>
        <p>
          {{item.housing_days}}天
        </p>
      </div> -->
      <!-- 收益金额 -->
      <!-- <div class="personal-information">
        <p>
          收益金额
        </p>
        <p>
          {{item.earnings | addPriceIcon}}
        </p>
      </div> -->
      <!-- 来源 -->
      <!-- <div class="personal-information boeder-no" style="font-size:3rem">
        <p>
          客人来源
        </p>
        <p>
          {{item.source}}
        </p>
      </div> -->
    </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      
    }
  },
  props:[
    'list'
  ],
  created(){
    // console.log(this.list)
  },
  methods:{
    emitToparent(){
      this.$router.push('/landlord-bill')
    }
  },
  filters:{
    addPriceIcon(value){
      return '￥' + value
    }
  },
  computed:{
    totalEarnings(){
      // this.list[0].
    }
  }
}
</script>
<style lang="less" scoped>
  .landlord{
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    // 收益
    .earnings{
      width: 100%;
      height: 3.24rem;
      background-image: url(../../assets/images/components-img/landlord-img/bag.png);
      margin-bottom: .6rem;
      // 账单明细
      .bill{
        font-size: 0.28rem;
        line-height: .28rem;
        font-family: Source Han Sans CN Regular, Source Han Sans CN Regular-Regular;
        font-weight: 400;
        color: #eeeeee;
        font-weight: bold;
        margin-top: .3rem;
        p{
          &:first-child{
            float: left;
            margin-left: .24rem;
          }
          &:last-child{
            float: right;
            margin-right: .24rem;
          }
        }
      }
      // 标题
      .one-title{
        text-align: center;
        font-size: .26rem;
        line-height: .26rem;
        color: #eeeeee;
        margin-top: .14rem;
      }
      // 总收益
      .earnings-money{
        text-align: center;
        font-size: .56rem;
        line-height: .56rem;
        font-family: Source Han Sans CN Bold, Source Han Sans CN Bold-Bold;
        font-weight: 700;
        color: #ffffff;
        letter-spacing: .02rem;
        margin-top: .12rem;
      }
      // 具体收益
      .three-kinds-of{
        width: 6.9rem;
        height: 1.7rem;
        margin: 0 auto;
        background: #ffffff;
        box-shadow: 0px 0px .1rem 0px rgba(0,180,255,0.24);
        border-radius: .1rem;
        margin-top: .42rem;
        display: flex;
        span{
          display: block;
          width: .03rem;
          height: .74rem;
          background-color: #E4E4E4;
          margin-top: .48rem;
        }
        .zc{
          color: #00B775;
        }
        div{
          width: 3.32rem;
          color: #ff4040;
          p{
            &:first-child{
              margin-top: .48rem;
              font-size: .28rem;
              line-height: .28rem;
              font-family: Source Han Sans CN Medium, Source Han Sans CN Medium-Medium;
              font-weight: 500;
              text-align: center;
            }
            &:last-child{
              font-size: .32rem;
              line-height: .32rem;
              font-weight: bold;
              text-align: center;
              margin-top: .28rem;
            }
          }
        }
      }
    }
    // 具体信息
    .landlord-content{
      width: 6.9rem;
      // height: 4.4rem;
      margin: 0 auto;
      margin-top: .3rem;
      box-shadow: 0px 0px .1rem 0px #cccccc;
      border-radius: .1rem;
      display: flex;
      flex-direction: column;
      flex: 1;
      // 位置时间
      .location-time{
        width: 100%;
        height: .38rem;
        margin-top: .3rem;
        font-size: .3rem;
        line-height: .38rem;
        margin-bottom: .13rem;
        span{
          display: inline-block;
          width: .08rem;
          height: .38rem;
          border-radius: .04rem;
          background-color: rgb(0, 136, 255);
          margin-left: .22rem;
          margin-right: .26rem;
          float: left;
        }
        .address{
          color: rgb(51, 51, 51);
          font-weight: bold;
          float: left;
        }
        .date{
          font-size: .24rem;
          color: rgb(102, 102, 102);
          float: right;
          margin-right: .3rem;
        }
      }
      // 入住人信息
      .personal-information{
        width: 6.3rem;
        height: .93rem;
        margin: 0 auto;
        // border-bottom: .01rem rgb(228, 228, 228) dashed ;
        line-height: .9rem;
        p{
          font-size: .28rem;
          &:first-child{
            float: left;
            color: rgb(51, 51, 51);
            width: 1.2rem;
          }
          &:nth-child(2){
            float: left;
            margin-left: .33rem;
            color: rgb(102, 102, 102);
          }
          &:nth-child(3){
            float: right;
            color: rgb(0, 136, 255);
          }
        }
      }
      .boeder-no{
        border: none;
      }
    }
  }
</style>>
